
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.883 11.954c.685 0 1.31-.181 1.872-.545a3.956 3.956 0 001.34-1.454 4.14 4.14 0 00.497-2.018c0-.726-.166-1.387-.497-1.981a3.887 3.887 0 00-1.34-1.424A3.44 3.44 0 0011.883 4c-.68 0-1.301.179-1.863.536a3.96 3.96 0 00-1.837 3.41c0 .739.165 1.41.496 2.017a3.92 3.92 0 001.34 1.45c.563.36 1.184.541 1.864.541zm0-1.723c-.346 0-.667-.1-.963-.303a2.156 2.156 0 01-.707-.822 2.542 2.542 0 01-.264-1.168c0-.41.088-.783.264-1.117.176-.334.412-.599.707-.795.296-.196.617-.295.963-.295.357 0 .682.097.975.29.293.194.526.458.7.792.172.333.258.708.258 1.125 0 .427-.086.814-.259 1.16a2.17 2.17 0 01-.699.826 1.663 1.663 0 01-.975.307zm5.124 9.51c1.506 0 2.259-.527 2.259-1.582 0-.61-.178-1.226-.532-1.85-.355-.624-.86-1.2-1.516-1.727-.657-.527-1.436-.952-2.338-1.274-.903-.323-1.902-.484-2.997-.484-1.096 0-2.095.161-2.997.484-.903.322-1.682.747-2.338 1.274-.656.527-1.162 1.103-1.516 1.727-.355.624-.532 1.24-.532 1.85 0 1.055.753 1.582 2.259 1.582h10.248zm.07-1.731H6.688c-.082 0-.14-.016-.175-.049a.175.175 0 01-.053-.136c0-.287.12-.615.36-.984.24-.37.594-.728 1.06-1.077.465-.348 1.034-.638 1.704-.87.671-.231 1.438-.347 2.299-.347s1.627.116 2.298.347c.671.232 1.24.521 1.705.87.466.349.82.708 1.06 1.077.24.369.36.697.36.984a.184.184 0 01-.049.136c-.032.033-.092.049-.18.049z","fill":"#848E9D"}})])
          )
        }
      }
    